
import _ from 'lodash'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { isCreate, isDelete, isUpdate, isView } from 'utils/verification.utils'

/** TRANSLATION */
import { useTranslation } from 'react-i18next'

/** COMPONENT */
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import { Box, Grid, InputAdornment } from '@mui/material'
import CreditFeeApi from 'api/setting/credit-fee-managements/credit-fee.api'
import HeaderCard from 'component/CardCustom/HeaderCard'
import { notiError } from 'component/notifications/notifications'
import TableCustom from 'component/Table/TableCustom'
import TableRowCommon from 'component/Table/TableRowCommon'
import MainButton from 'new-components/buttons/main-button'
import SelectInput from 'new-components/inputs/select-input'
import TextInput from 'new-components/inputs/text-input'
import AlertModal from 'new-components/modal/alert-modal'
import SnackbarComponent from 'new-components/snackbar/snackbar-component'
import { useHistory } from 'react-router-dom'
import { routeName } from 'routes/routes-name'
import { toBuddhistYear } from 'utils/app.utils'

const permissions = {
  isCreate: isCreate(),
  isDelete: isDelete(),
  isUpdate: isUpdate(),
  isView: isView()
}
export default function CreditFee() {
  const { t } = useTranslation()
  const history = useHistory()

  const [creditFees, setCreditFee] = useState([])

  /** PAGINATION  */
  const [page, setPage] = useState(1)
  const [pageLimit, setPageLimit] = useState(10)
  const [rowCount, setRowCount] = useState(0)
  const [sortBy, setSortBy] = useState('createAt')
  const [sortType, setSortType] = useState('ASC')
  const [search, setSearch] = useState('')
  const [status, setStatus] = useState('ALL')

  const [isOpenAlertModal, setIsOpenAlertModal] = useState(false)
  const [statusAlertModal, setStatusAlertModal] = useState('')
  const [id, setId] = useState<number>(0)
  const [name, setName] = useState('')
  const [isOpenSnack, setIsOpenSnack] = useState(false)
  const [typeSnack, setTypeSnack] = useState<any>("success")
  const [labelSnack, setLabelSnack] = useState('')

  const loadData = async () => {
    try {
      const resp = await CreditFeeApi.findAll({
        page: page,
        pageLimit: pageLimit,
        search: search,
        sortBy: sortBy,
        sortType: sortType,
        status: status === 'ALL' ? '' : status
      })
      if (resp.status === 200) {
        setRowCount(resp.headers['x-total'])
        setCreditFee(resp.data)
      } else {
        setCreditFee([])
      }
    } catch (error) {
      notiError('ERROR')
    }
  }

  useEffect(() => {
    loadData()
  }, [page, pageLimit, sortBy, sortType])

  const onCreate = () => {
    history.push(routeName.creditFee + '/create')
  }

  const handleChangeStatus = (statusVal: string) => {
    setStatus(statusVal)
  }

  const onActive = () => {
    if (id) {
      CreditFeeApi.updateStatus(id, statusAlertModal).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('CREDIT_FEE.MESSAGE.SUCCESS.UPDATE_STATUS'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('CREDIT_FEE.MESSAGE.ERROR'))
        }
      })
    }
  }



  const onDelete = () => {
    if (id) {
      CreditFeeApi.remove(id).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('CREDIT_FEE.MESSAGE.SUCCESS.DELETE'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('CREDIT_FEE.MESSAGE.ERROR.DEFAULT'))
        }
      })
    }
  }

  const onEdit = (data: any) => {
    const { CreditFeeId } = data
    history.push(`${routeName.creditFee}/${CreditFeeId}`)
  }

  const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
    setSortType(sortTypeVal)
    setSortBy(sortByVal)
  }

  const handleChangePage = (val: number) => {
    setPage(val)
  }

  const handleChangeRowsPerPage = (limit: number) => {
    setPageLimit(limit)
  }

  const headCells = [
    { id: 'no', disablePadding: false, label: '#', width: '60px' },
    { id: 'creditFeeName', disablePadding: false, label: t(`CREDIT_FEE.FORM.CF_NAME`) },
    // { id: 'amount', disablePadding: false, label: t(`CREDIT_FEE.FORM.CF_B`), width: '185px' },
    { id: 'dateStart', disablePadding: false, label: t('CREDIT_FEE.FORM.USE_DATE'), width: '130px' },
    { id: 'templateDoctorFee', disablePadding: false, label: t('CREDIT_FEE.FORM.TEMPLATE_DF') },
    { id: 'doctors', disablePadding: false, label: t('USER_DOCTOR'), width: '250px' },
    { id: 'status', disablePadding: false, label: t('TABLE.CELL.STATUS'), width: '200px' },
    { id: 'updatedBy', disablePadding: false, label: t('TABLE.CELL.UPDATED_BY'), width: '200px' },
    { id: 'action', disablePadding: false, label: 'Action', width: '80px' }
  ]

  const renderData = (objData: any, no: number) => {
    no = page * pageLimit - pageLimit + no + 1
    const { CreditFeeId, CreditFeeName, amount, dateStart, doctors, status: dfStatus, updatedAt, updatedBy } = objData

    let doctor = doctors ? doctors.split(',') : []
    if (!_.isEmpty(doctor) && _.size(doctor) > 1) doctor = `${doctor[0]} และอีก ${_.size(doctor) - 1} คน`
    else if (!_.isEmpty(doctor)) doctor = doctor[0]
    else doctor = '-'

    const statusBtnActive = dfStatus === 'ACTIVE' ? true : permissions.isUpdate.disabled
    const statusBtnInActive = dfStatus === 'INACTIVE' ? true : permissions.isUpdate.disabled

    const templateCreditFeeName = objData.templateCreditFee ? objData.templateCreditFee.templateCreditFeeName : '-'
    const objRenderData = {
      key: CreditFeeId,
      id: CreditFeeId,
      obj: objData,
      columns: [
        { option: 'TEXT', align: 'center', label: no },
        { option: 'TEXT', align: 'left', label: CreditFeeName, class: 'text-ellipsis' },
        // { option: 'TEXT', align: 'left', label: `${amount}:${3 - amount > 0 ? numberFormat(3 - amount, 0, 3) : 0}` },
        { option: 'TEXT', align: 'left', label: toBuddhistYear(moment(dateStart), 'DD/MM/YYYY') },
        { option: 'TEXT', align: 'left', label: templateCreditFeeName, class: 'text-ellipsis' },
        { option: 'TEXT', align: 'left', label: doctor },
        { option: 'STATUS', align: 'center', label: dfStatus },
        { option: 'UPDATE_BY', align: 'center', label: { updatedBy: updatedBy, updatedAt: updatedAt } },
        {
          option: 'ACTION',
          align: 'center',
          label: 'action',
          values: [
            { option: 'STATUS_ACTIVE', label: t(`STATUS.ACTIVE`), disabled: statusBtnActive },
            { option: 'STATUS_INACTIVE', label: t(`STATUS.INACTIVE`), disabled: statusBtnInActive },
            { option: 'DIVIDER', label: '', disabled: false },
            { option: 'EDIT', label: t(`BUTTON.EDIT`), disabled: permissions.isUpdate.disabled },
            { option: 'DELETE', label: t(`BUTTON.DELETE`), disabled: permissions.isDelete.disabled }
          ]
        }
      ]
    }
    return (
      <TableRowCommon
        {...objRenderData}
        onactive={() => handleSubmitModal(Number(objRenderData.id), 'ACTIVE', objRenderData.obj)}
        oninactive={() => handleSubmitModal(Number(objRenderData.id), 'INACTIVE', objRenderData.obj)}
        onedit={() => onEdit(objRenderData.obj)}
        ondelete={() => handleSubmitModal(Number(objRenderData.id), 'DELETE', objRenderData.obj)}
      />
    )
  }

  const handleSubmitModal = (id: number, status: string, obj?: any) => {
    setStatusAlertModal(status)
    setId(id)
    setIsOpenAlertModal(true)
    setName(obj.doctorFeeName)
  }


  return (
    <Box>
      <AlertModal
        isOpen={isOpenAlertModal}
        title={t(`CREDIT_FEE.ALERT.${statusAlertModal === 'DELETE' ? 'TITLE_DELETE' : 'TITLE_ACTIVE'}`)}
        message={t(`CREDIT_FEE.ALERT.${statusAlertModal === 'DELETE' ? 'CONFIRM_DELETE_' : 'CONFIRM_STATUS'}`, { CreditFeeName: name, status: t(`DOCTOR_FEE.ALERT.${statusAlertModal}`) })}
        type={statusAlertModal === 'DELETE' ? 'error' : 'warning'}
        handleClose={() => setIsOpenAlertModal(false)}
        onCancel={{ onClick: () => setIsOpenAlertModal(false), title: t('BUTTON.CANCEL') }}
        onSubmit={{ onClick: statusAlertModal === 'DELETE' ? onDelete : onActive, title: t('BUTTON.SUBMIT') }}
      />
      <SnackbarComponent
        onOpen={isOpenSnack}
        onClose={() => setIsOpenSnack(false)}
        label={labelSnack}
        type={typeSnack}
        transform={`translateX(calc(100vw - 100% - 32px)) translateY(calc(-100vh + 100% + ${window.innerHeight - 50}px))`}
        autoHideTime={3000}
      />
      <HeaderCard text={t('MENU.CREDIT_FEE')} />
      <Box paddingX="24px" paddingTop="16px">
        <Grid container spacing="16px">
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <TextInput
              label={t('INPUT.SEARCH')}
              value={search}
              onChange={(event) => {
                setSearch(event.target.value)
              }}
              fullWidth
              inputProps={{
                endAdornment: (
                  <InputAdornment position="end" >
                    {!search ? <FontAwesomeIcon icon={faSearch} style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 15 }} /> :
                      <FontAwesomeIcon
                        icon={faTimes}
                        onClick={() => {
                          setSearch('');
                        }}
                        style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 17, cursor: 'pointer' }} />}
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <SelectInput
              onChange={(event) => {
                const value = event.target.value
                if (value) {
                  handleChangeStatus(value)
                }
              }}
              options={[
                { value: 'ALL', name: t('STATUS.ALL') },
                { value: 'ACTIVE', name: t('STATUS.ACTIVE') },
                { value: 'INACTIVE', name: t('STATUS.INACTIVE') },
              ]}
              value={status}
              label={t('STATUS.LABEL')}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} xl={8}>
            <Box display={'flex'} justifyContent={'space-between'}>
              <MainButton
                title={t('INPUT.SEARCH')}
                type='primary'
                variant='contained'
                style={{ width: '120px' }}
                onClick={() => {
                  setPage(1)
                  loadData()
                }} />

              <MainButton title={t('CREDIT_FEE.FORM.ADD_CF')} disabled={permissions.isCreate.disabled} type='primary' variant='contained' onClick={() => onCreate()} startIcon={<AddCircleIcon />} />
            </Box>
          </Grid>
        </Grid>
        <Box paddingTop="24px">
          <TableCustom
            page={page}
            pageLimit={pageLimit}
            sortType={sortType}
            sortBy={sortBy}
            onSort={onRequestSort}
            setPageLimit={handleChangeRowsPerPage}
            setPage={handleChangePage}
            rowCount={rowCount}
            headCells={headCells}
            rowsData={creditFees.map((val, i) => {
              return renderData(val, i)
            })}
            tableFixedWidth
            tableMinWidth={1536}
          />
        </Box>
      </Box>
    </Box>
  )
}

